<template>
  <div class="page flex-col">
    <div class="group_1 flex-row justify-end scaler">
      <div class="group_2 flex-col justify-between">
        <div class="group_3 flex-row justify-between">
          <div class="section_1 flex-col"></div>
          <div class="text-wrapper_1 flex-col justify-between">
            <span class="text_1">Get&nbsp;Started</span>
            <span class="text_2">登录即刻体验AI面试官</span>
          </div>
        </div>
        <router-view></router-view>
      </div>
      <div class="group_12 flex-col">
        <div class="group_13 flex-col">
          <div class="text-wrapper_7 flex-row"><span class="text_13">AI面试官</span></div>
          <div class="text-wrapper_8 flex-row">
            <span class="paragraph_1">
              提升求职效率
              <br />
              优化招聘流程
              <br />
              改善学习方法
            </span>
          </div>
          <a href="https://beian.miit.gov.cn/" target="_blank" style="position:absolute;bottom:15px;right:185px;font-size:large;">粤ICP备2025376732号-1</a>
          <div class="text-wrapper_9 flex-row"><span class="text_14">屿智同行</span></div>
        </div>
      </div>
      <div class="image-wrapper_1 flex-col">
        <img class="image_2" referrerpolicy="no-referrer"
          src="./assets/img/FigmaDDSSlicePNGf483b8231855f2bab0e0b42a834d15f3.png" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeTab: 'login',
      phone: '',
      password: '',
      agree: false,
      selectedFile: null,
    };
  },
  methods: {
    
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
/* .scaler {
  transform-origin: top left;
  transform: scale(0.67);
} */

@media (max-width: 1600px) {
  .scaler {
    transform-origin: top left;
    transform: scale(0.67);
  }
}

@media (min-width: 1600px) {
  .scaler {
    transform-origin: bottom right;
    transform: scale(0.8);
  }
}

</style>